import { htmlSanitizer } from './htmlSanitizer';

/**
 * Sanitizes HTML written outside the Portal and shown inside it, such as a map balloon or a case description sent by
 * email. It keeps the markup such documents are made of: text, lists, tables with their presentational attributes,
 * font, links, and images carried inline. Styles, classes, ids and SVG go, as they could cover or restyle the page.
 */
export const sanitizeDocumentHtml = htmlSanitizer({
  ALLOWED_TAGS: (
    'a abbr b big blockquote br caption center cite code col colgroup dd del div dl dt em font h1 h2 h3 h4 h5 h6 hr ' +
    'i img ins li ol p pre q s small span strike strong sub sup table tbody td tfoot th thead tr tt u ul'
  ).split(' '),
  ALLOWED_ATTR: [
    'href',
    'src',
    'alt',
    'title',
    'width',
    'height',
    'align',
    'valign',
    'colspan',
    'rowspan',
    'span',
    'border',
    'cellpadding',
    'cellspacing',
    'bgcolor',
    'color',
    'face',
    'size'
  ]
});
